/**
 * Texto del aviso cuando SUNAT acepta el comprobante con observaciones (estado 07).
 *
 * Vive acá y no dentro del componente para poder testearlo sin montar Vue. El BFF manda
 * `observado: true` y la lista de `observaciones`; el front solo arma el texto que ve la
 * vendedora, y guarda el comprobante igual que un aceptado para no duplicarlo.
 */

const TEXTO_POR_DEFECTO = 'Comprobante aceptado con observaciones'
const SEPARADOR = ' · '

/**
 * @param {object} data respuesta del BFF (`message` y `observaciones`)
 * @returns {string} mensaje legible para el aviso
 */
const construirAvisoObservado = (data) => {
    const payload = data || {}

    const mensaje =
        typeof payload.message === 'string' && payload.message.trim() !== ''
            ? payload.message.trim()
            : TEXTO_POR_DEFECTO

    const observaciones = Array.isArray(payload.observaciones) ? payload.observaciones : []
    const detalles = observaciones
        .filter((detalle) => typeof detalle === 'string' && detalle.trim() !== '')
        .map((detalle) => detalle.trim())

    return [mensaje, ...detalles].join(SEPARADOR)
}

module.exports = { construirAvisoObservado }
